/**
 * Unterscheidet "kein Internet" von "Internet da, aber PocketBase nicht
 * erreichbar" – zwei völlig verschiedene Fehlerbilder, die pbErrorMessage()
 * (Statuscode 0) bisher nicht auseinanderhalten konnte.
 */
import { pb } from "@/lib/pocketbase";

export interface ConnectivityStatus {
  deviceOnline: boolean;
  backendReachable: boolean;
  internetReachable: boolean;
}

export async function checkConnectivity(): Promise<ConnectivityStatus> {
  if (!navigator.onLine) {
    return { deviceOnline: false, backendReachable: false, internetReachable: false };
  }
  const backendReachable = await pb.health
    .check({ signal: AbortSignal.timeout(5_000) })
    .then(() => true)
    .catch(() => false);
  if (backendReachable) return { deviceOnline: true, backendReachable: true, internetReachable: true };

  // PocketBase antwortet nicht – prüfen, ob überhaupt Internet da ist.
  // `no-cors` liefert nur bei echtem Netzwerkfehler eine Ablehnung; der
  // (undurchsichtige) Statuscode selbst spielt keine Rolle, es geht nur
  // darum, ob die Anfrage überhaupt rausging.
  const internetReachable = await fetch("https://www.gstatic.com/generate_204", {
    mode: "no-cors",
    signal: AbortSignal.timeout(4_000),
  })
    .then(() => true)
    .catch(() => false);
  return { deviceOnline: true, backendReachable: false, internetReachable };
}

export function connectivityMessage(status: ConnectivityStatus): string {
  if (!status.deviceOnline || !status.internetReachable) {
    return "Kein Internet – die App läuft mit zwischengespeicherten Daten weiter.";
  }
  return "Internet ist da, aber der PocketBase-Server antwortet nicht (Backend-Problem, nicht dein WLAN).";
}
